module.exports = __webpack_public_path__ + "static/slide-2-864cdae0a54cebdd5158bfd9124b57de.jpg";